import React, { useState } from 'react';
import './App.css';
import StorageForm from './components/StorageForm'
import CalculationTable from './components/CalculationTable'

function App() {
  const [haEnabled, setHaEnabled] = useState(true);
  const [numNodes, setNumNodes] = useState(1000);
  const [loggingEnabled, setLoggingEnabled] = useState(true);
  const [mySqlLocal, setMySqlLocal] = useState(true);
  const [numMySqlBackups, setNumMySqlBackups] = useState(0);
  const [numImages, setNumImages] = useState(0);
  const [imageSize, setImageSize] = useState(0);

  const handleHaEnabled = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHaEnabled((event.target as HTMLInputElement).checked);
  }
  
  const handleNumNodes = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNumNodes(Number((event.target as HTMLInputElement).value));
  }
  
  const handleLogging = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoggingEnabled((event.target as HTMLInputElement).checked);
  }

  const handleNumImages = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNumImages(Number((event.target as HTMLInputElement).value));
  }

  const handleImageSize = (event: React.ChangeEvent<HTMLInputElement>) => {
    setImageSize(Number((event.target as HTMLInputElement).value));
  }

  const handleMySqlLocal = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMySqlLocal((event.target as HTMLInputElement).checked);
  }

  const handleNumMySqlBackups = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNumMySqlBackups(Number((event.target as HTMLInputElement).value));
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <StorageForm
            haEnabled={haEnabled}
            numNodes={numNodes}
            numImages={numImages}
            imageSize={imageSize}
            loggingEnabled={loggingEnabled}
            mySqlLocal={mySqlLocal}
            numMySqlBackups={numMySqlBackups}
            handleHaEnabled={handleHaEnabled}
            handleLogging={handleLogging}
            handleNumNodes={handleNumNodes}
            handleNumImages={handleNumImages}
            handleImageSize={handleImageSize}
            handleMySqlLocal={handleMySqlLocal}
            handleNumMySqlBackups={handleNumMySqlBackups}
          />
        </div>
        <div className="col">
          <CalculationTable
            haEnabled={haEnabled}
            numNodes={numNodes}
            numMySqlBackups={numMySqlBackups}
            numImages={numImages}
            imageSize={imageSize}
            loggingEnabled={loggingEnabled}
            mySqlLocal={mySqlLocal}
          />
        </div>
      </div>
    </div>
  )
}

export default App;
